import React, { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { connect, useDispatch } from 'react-redux'
import Page from '../../component/page'
import CourseOverview from '../../component/CourseOverview'
import CourseHeader from '../course/CourseHeader'
import { nameById as nameCountryById } from '../../js/countries'
import { nameById as nameStateById } from '../../js/states'

const loadCourseGroup = (id) => ({
  type: 'LOAD_COURSE_GROUP',
  id,
  payload: {
    request: {
      url: `/v3/course/${id}/layouts`,
    },
  },
})

const locationLabelFor = (group) =>
  group.country === 236
    ? nameStateById(group.state)
    : nameCountryById(group.country)

function CourseGroup({ groups }) {
  const dispatch = useDispatch()
  const params = useParams()
  const navigate = useNavigate()
  const { id } = params
  console.log('CourseGroup params', params)

  const loadGroup = () => {
    console.log('loadGroup')
    const group = groups.find((group) => group.id === id)

    if (!group || group.id !== id || group.courses === undefined) {
      dispatch(loadCourseGroup(id))
    }
  }

  useEffect(() => {
    loadGroup()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  const onCourseClicked = (course) => {
    console.log('Click course', course)
    navigate(`/course/${id}/${course.id}`)
  }

  const group = groups.find((group) => group.id == id) // eslint-disable-line eqeqeq

  console.log('group', group, groups)
  if (group && group.courses !== undefined) {
    const courses = group.courses
    return (
      <Page className="container course">
        <div className="row">
          <div className="col-12">
            <CourseHeader
              name={group.name}
              groupId={group.id}
              location={group.location}
              locationLabel={locationLabelFor(group)}
            />
            <h2>Layouts</h2>
            {courses.map((course, index) => (
              <CourseOverview
                key={index}
                course={course}
                onClicked={onCourseClicked}
              />
            ))}
          </div>
        </div>
      </Page>
    )
  }

  return (
    <Page className="container">
      <div className="row">
        <div className="col-12">
          <h1>Loading courses...</h1>
        </div>
      </div>
    </Page>
  )
}

const mapStateToProps = (state) => {
  return {
    course: state.course,
    groups: state.groups.data,
  }
}

export default connect(mapStateToProps)(CourseGroup)
